import PermissionService from '@/services/PermissionService';
const APP_STORAGE_KEY_ROLES = 'OMNI_WEBAPP_ROLES';

export interface RolesState {
  roles: {
    admin: boolean,
    chat: boolean,
    everyone: boolean,
    orders: boolean,
    products: boolean,
  };
}

export const RolesModule = {
  state: {
    roles: window.localStorage.getItem(APP_STORAGE_KEY_ROLES) &&
      JSON.parse(window.localStorage.getItem(APP_STORAGE_KEY_ROLES) as any) || {
        admin: false,
        chat: false,
        everyone: false,
        orders: false,
        products: false,
      },
  },
  mutations: {
    setRoles(state: any, roles: any) {
      if (roles) {
        window.localStorage.setItem(APP_STORAGE_KEY_ROLES, JSON.stringify(roles));
      } else {
        window.localStorage.removeItem(APP_STORAGE_KEY_ROLES);
      }
      state.roles = roles;
    },
  },
  actions: {
    loadRoles({commit}: any): Promise<any> {
      return PermissionService.getRoles().then((res: string[]) => {
        const roles: any = {
          admin: false,
          chat: false,
          everyone: false,
          orders: false,
          products: false,
        };
        res.forEach((val) => {
          roles[val] = true;
        });
        commit('setRoles', roles);
        return roles;
      });
    },
  },
};
